const zarCurrencyFormatter = new Intl.NumberFormat('en-ZA', {
    style: 'currency',
    currency: 'ZAR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
});

export function formatAtokuCurrency(value: unknown): string {
    const amount = Number(value ?? 0);
    return Number.isFinite(amount) ? zarCurrencyFormatter.format(amount) : 'NaN';
}
